import styled from 'styled-components/native';

export default styled.View`
  border: 1px solid rgba(255, 255, 255, 0.24);
  width: 100%;
`;
